export default __webpack_public_path__ + "static/media/background.a5e71c49.png";